/**
 * Technical Analysis Showcase - Deep technical analysis workspace
 * Demonstrates: Indicators, Pine Editor, Drawings, Multiple panes
 */
export const technicalShowcase = {
    name: "technical",
    label: "Phân tích kỹ thuật",
    description: "Workspace chuyên sâu với multiple panes và indicators",
    layout: { rows: 2, cols: 1 },
    charts: [
        {
            id: "btc-technical-main",
            symbol: "BTCUSDT",
            timeframe: "15m",
            symbolLinkGroup: "B",
        },
        {
            id: "btc-technical-volume",
            symbol: "BTCUSDT",
            timeframe: "15m",
            symbolLinkGroup: "B",
        },
    ],
    defaultChartProps: {
        showToolbar: true,
        showHeader: true,
        showFooter: true,
        drawingUiEnabled: true,
        theme: "classic-dark",
        // Pre-configured panes for technical analysis
        panes: [
            {
                id: "price",
                label: "Price",
                visible: true,
                heightRatio: 3,
                pinned: false,
                splitScale: false,
                tooltip: "value",
                series: [
                    { id: "price-main", type: "Candlestick", yAxis: "right" },
                    { id: "ema-20", type: "EMA", yAxis: "right", params: { period: 20 } },
                    { id: "ema-50", type: "EMA", yAxis: "right", params: { period: 50 } },
                    { id: "bb", type: "BollingerBands", yAxis: "right", params: { period: 20, stdDev: 2 } },
                ],
            },
            {
                id: "volume",
                label: "Volume",
                visible: true,
                heightRatio: 1,
                pinned: false,
                splitScale: false,
                tooltip: "value",
                series: [
                    { id: "vol-main", type: "Volume", yAxis: "right" },
                ],
            },
            {
                id: "rsi",
                label: "RSI",
                visible: true,
                heightRatio: 1,
                pinned: false,
                splitScale: true,
                tooltip: "value",
                series: [
                    { id: "rsi-14", type: "RSI", yAxis: "right", params: { period: 14 } },
                ],
            },
            {
                id: "macd",
                label: "MACD",
                visible: true,
                heightRatio: 1,
                pinned: false,
                splitScale: true,
                tooltip: "value",
                series: [
                    { id: "macd-main", type: "MACD", yAxis: "right", params: { fastPeriod: 12, slowPeriod: 26, signalPeriod: 9 } },
                ],
            },
        ],
    },
    syncSettings: {
        syncVisibleRange: true,
        syncCrosshair: true,
        syncDrawings: true,
        syncSymbolLinks: true,
        syncTimeframe: true,
        syncChartType: true,
    },
    featuredPanels: ["pine_editor", "drawings", "indicators"],
    activeBottomTab: "pine_editor",
};
